import { initialDataWithPagination } from "services/api/consts";
import { TableSearch } from "ui/components/Table/TableSearch";

import { USAGE_SEARCH_COLUMNS } from "./consts";
import { UsageSearchResultsProps } from "./types";

const UsageSearchResults: React.FC<UsageSearchResultsProps> = ({
  searchResults,
  isLoading,
  onPaginationChange,
  onRowClick,
}) => {
  return (
    <TableSearch
      columns={USAGE_SEARCH_COLUMNS}
      data={searchResults.data}
      pagination={searchResults.pagination || initialDataWithPagination.pagination}
      selectableRows={false}
      selectedRows={[]}
      onPaginationChange={onPaginationChange}
      onSelectedChange={() => undefined}
      isLoading={isLoading}
      onRowClick={onRowClick}
    />
  );
};

export default UsageSearchResults;
